import type { ReactElement } from 'react';

interface OperatorModulePageProps {
  title: string;
}

export default function OperatorModulePage({ title }: OperatorModulePageProps): ReactElement {
  return (
    <main
      className="animate-fade-in flex flex-col p-6 mx-auto w-full"
      style={{
        gap: 20,
        backgroundColor: 'var(--color-bg, #fcfaf8)',
        minHeight: '100vh',
        maxWidth: 1200,
      }}
    >
      <header className="mb-2">
        <h1 className="font-bold tracking-tight" style={{ fontSize: 24, color: 'var(--color-text, #2d2418)' }}>{title}</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-muted, #a89b8a)', marginTop: 4 }}>
          Маршрут operator-модуля восстановлен в CRM shell.
        </p>
      </header>

      <section className="card flex flex-col" style={{ padding: 24 }}>
        <h2 className="font-semibold" style={{ fontSize: 16, color: 'var(--color-text, #2d2418)' }}>
          Route skeleton parity
        </h2>
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary, #6b5e4f)', marginTop: 4 }}>
          Маршрут доступен в app shell для ERP2 parity. Реализация модуля выполняется в [PHASE-2].
        </p>
        <div style={{ marginTop: 16, fontSize: 13, color: 'var(--color-text-muted, #a89b8a)' }}>
          Пока доступен только каркас маршрута без runtime-логики.
        </div>
      </section>
    </main>
  );
}
